<template>
  <vue-scroll class="view box grow flex gaps grid-2">
    <el-collapse v-model="activeNames" accordion ref="activation-steps" style="margin: auto">
      <el-collapse-item title="COMPLETE YOUR PROFILE" ref="collapse-profile" name="profile-accordian">
        <el-form ref="profileForm" :model="profile" label-width="120px" label-position="top">
          <el-form-item label="First Name"> <el-input v-model="profile.firstname"></el-input> </el-form-item>
          <el-form-item label="Last Name"> <el-input v-model="profile.lastname"></el-input> </el-form-item>
          <el-form-item label="Position"> <el-input v-model="profile.position"></el-input> </el-form-item>
        </el-form>
        <div class="flex gaps justify-flex-end">
          <span class="box text-button uppercase cursor-pointer" @click="openAccordion('network-accordian')">next</span>
        </div>
      </el-collapse-item>
      <el-collapse-item title="CHECK YOUR NETWORK REQUIREMENTS" ref="collapse-network" name="network-accordian">
        <div class="network-req">
          <p class="subtitle2">Please check your network and ensure the ports listed below are open.</p>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-etcd-0.${networkInfo.customer_name}.confluera.com:2379`
          }}</span>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-etcd-1.${networkInfo.customer_name}.confluera.com:2379`
          }}</span>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-etcd-2.${networkInfo.customer_name}.confluera.com:2379`
          }}</span>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-kafka-0.${networkInfo.customer_name}.confluera.com:9092`
          }}</span>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-kafka-1.${networkInfo.customer_name}.confluera.com:9092`
          }}</span>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-kafka-2.${networkInfo.customer_name}.confluera.com:9092`
          }}</span>
          <span class="body2 display-block">{{
            `${networkInfo.environment}-schema-registry-0.${networkInfo.customer_name}.confluera.com:8181`
          }}</span>
        </div>
        <div class="flex gaps justify-flex-end">
          <span class="box text-button uppercase cursor-pointer" @click="openAccordion('profile-accordian')">prev</span>
          <span class="box text-button uppercase cursor-pointer" @click="openAccordion('agent-accordian')">next</span>
        </div>
      </el-collapse-item>
      <el-collapse-item title="INSTALL CONFLEURA AGENTS" ref="collapse-agent" name="agent-accordian">
        <div class="flex columns gaps">
          <div class="box subtitle2">
            <h6 class="el-tabs__header os-title">OS Type</h6>
            <li
              class="display-block cursor-pointer"
              :class="{ 'is-active': osSelection.os_name === os.os_name && osSelection.os_version === os.os_version }"
              v-for="(os, idx) in osSupportList[activePanel]"
              :key="idx"
              @click="changeOsSelection(os)"
            >
              <h6>{{ `${os.os_name} ${os.os_version}` }}</h6>
            </li>
          </div>

          <div class="box grow">
            <el-tabs v-model="activePanel">
              <el-tab-pane label="Linux" name="Linux">
                <ubuntu-instructions
                  v-if="osSelection.os_name === 'Ubuntu'"
                  :version="networkInfo.agent_version"
                ></ubuntu-instructions>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="flex gaps justify-flex-end">
          <span class="box text-button uppercase cursor-pointer" @click="openAccordion('network-accordian')">prev</span>
          <span class="box text-button uppercase cursor-pointer" @click="landingPage()">done</span>
        </div>
      </el-collapse-item>
    </el-collapse>
  </vue-scroll>
</template>

<script>
import { mapGetters } from "vuex";
import { NETWORK_INFO_REQ, NETWORK_INFO_SUCCESS } from "@/store/modules/network_info/network-info.type";

import { OS_SUPPORT_LIST_REQ, OS_SUPPORT_LIST_SUCCESS } from "@/store/modules/os_support/os-support.type";

import { ONBOARD_REQ, ONBOARD_SUCCESS } from "@/store/modules/onboard/onboard.type";
import { TRAIL_SUMMARY_REQ } from "@/store/modules/trails/trailsinfo.type";

import UbuntuInstructions from "@/components/os-template/UbuntuInstructions.vue";

export default {
  name: "Activation",
  data() {
    return {
      activeNames: ["profile-accordian"],
      activePanel: "Linux", // default to linux
      profile: {
        firstname: "",
        lastname: "",
        position: ""
      },
      osSelection: {
        os_name: "",
        os_version: ""
      }
    };
  },
  methods: {
    openAccordion(itemName) {
      this.$refs["activation-steps"].setActiveNames(itemName);
    },
    changeOsSelection(sel) {
      this.osSelection = sel;
    },
    landingPage() {
      // update profile then proceed to landing page
      if (this.$parent.disableNav) {
        this.$set(this.$parent, "disableNav", false);
      }

      this.$store.dispatch(ONBOARD_REQ, { onboard: true }).then(
        () => {
          this.$store.dispatch(TRAIL_SUMMARY_REQ).then(summaryInfo => {
            // else main system health dashboard
            if (this.insightsEnabled) {
              this.$router.push("/home");
            } else if (summaryInfo.numActiveTrails > 0) {
              this.$router.push({ name: "dashboard-trails" });
            } else if (summaryInfo.numPrivilegedTrails > 0) {
              // else direct to privilege trail dashboard
              this.$router.push({ name: "dashboard-privileged" });
            } else {
              this.$router.push({ name: "dashboard-agents" });
            }
          });
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  created() {
    // collpase main nav and disable clicks
    if (!this.$parent.disableNav) {
      this.$set(this.$parent, "disableNav", true);
    }
    if (!this.$parent.collapseNav) {
      this.$set(this.$parent, "collapseNav", true);
    }
    // set profile info
    this.profile.firstname = this.userProfile.firstname;
    this.profile.lastname = this.userProfile.lastname;

    Promise.all([this.$store.dispatch(NETWORK_INFO_REQ), this.$store.dispatch(OS_SUPPORT_LIST_REQ)]);
  },
  mounted() {
    this.$nextTick(() => {
      function disableHeaderClick() {
        return false;
      }
      this.$refs["collapse-profile"].handleHeaderClick = disableHeaderClick;
      this.$refs["collapse-network"].handleHeaderClick = disableHeaderClick;
      this.$refs["collapse-agent"].handleHeaderClick = disableHeaderClick;
      disableHeaderClick();
    });
  },
  computed: {
    ...mapGetters(["userProfile", "networkInfo", "osSupportList", "insightsEnabled"])
  },
  components: {
    UbuntuInstructions
  },
  watch: {
    osSupportList: function(newList, oldList) {
      if (newList !== oldList && !_.isEmpty(newList)) {
        if (newList.Linux) {
          this.osSelection = newList.Linux[0];
        }
      }
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
@import "assets/styles/text.css";

.view {
  background-color: var(--tuna-900);
}

.network-req {
  > span {
    border-bottom: 1px solid var(--border-color);
    padding: 8px 0px;

    &:last-of-type {
      margin-bottom: 24px;
    }
  }
}

.el-collapse {
  border: 1px solid var(--tuna-700);
}

>>> .el-collapse-item__header {
  color: white;
  padding: 0 24px;
  background-color: var(--tuna-800-50);
  border-bottom: 1px solid var(--tuna-800);

  &:not(.is-active):hover {
    opacity: 1;
  }

  &.is-active {
    border-bottom: none;
    background-color: var(--denim-700);
  }
}

>>> .el-tabs__active-bar {
  color: var(--aluminum-700);
  background-color: var(--aluminum-700);
}

>>> .el-tabs__item {
  font-size: 10px;
  font-weight: normal;
  color: var(--aluminum-700);
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

>>> .el-collapse-item__arrow {
  display: none;
}

>>> .el-collapse-item__content {
  margin: 0 24px;
}

.el-form--label-top {
  margin-top: 24px;
}

.text-button {
  color: var(--denim-700);
}

.os-title {
  line-height: 40px;
  margin: 0 0 15px;
}

li {
  > h6 {
    color: var(--aluminum-700);
  }

  &.is-active {
    > h6 {
      color: var(--denim-700);
    }
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}
</style>



// WEBPACK FOOTER //
// src/views/activation/Activation.vue